// pages/Home.js
import React, { useRef } from "react";
import Header from "../components/SetNavbar";
import Footer from "../components/Footer";
import Section1 from "../components/Section1";
import Offer from "../components/Offer";
import Webinar from "../components/Webinar";
import Email from "../components/Email";
import CourseOffer from "../components/CourseOffer";
import { Box } from "@mui/material";

const Home = () => {
  // Create a ref for the CourseOffer section
  const courseOfferRef = useRef(null);

  // Function to scroll to CourseOffer
  const scrollToCourses = () => {
    if (courseOfferRef.current) {
      courseOfferRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <>
      <Header scrollToCourses={scrollToCourses} />
      <Box sx={{ backgroundColor: "#0d192f" }}>
        <Section1 />
        <Offer />
        <div ref={courseOfferRef}>
          <CourseOffer />
        </div>
        <Webinar />
        <Email />
      </Box>
      <Footer />
    </>
  );
};

export default Home;
